const LOGO = "https://customer-assets.emergentagent.com/job_entertainment-hub-187/artifacts/jgyw0hiu_1000010836.png";

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 py-12">
      <div className="max-w-4xl mx-auto px-6 flex flex-col items-center text-center">
        <img src={LOGO} alt="Robust Entertainment" className="h-16 w-auto mb-5" />
        <p className="text-base text-zinc-400 leading-relaxed max-w-md">
          Complete entertainment solutions for holiday centres, leisure venues and live entertainment brands.
        </p>
        <div
          className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-zinc-300"
          data-testid="footer-contact"
        >
          <a href="tel:+447539528505" className="hover:text-[#D4AF37] transition-colors">
            07539 528 505
          </a>
          <span className="hidden sm:inline text-zinc-600">·</span>
          <a href="mailto:paul@robustentertainment.com" className="hover:text-[#D4AF37] transition-colors">
            paul@robustentertainment.com
          </a>
          <span className="hidden sm:inline text-zinc-600">·</span>
          <a
            href="https://www.robustentertainment.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#D4AF37] transition-colors"
          >
            www.robustentertainment.com
          </a>
        </div>
        <div className="mt-8 space-y-2 text-sm" data-testid="footer-copyright">
          <p className="text-metal font-semibold tracking-wide">
            Copyright {new Date().getFullYear()} Robust Entertainment Ltd.
          </p>
          <p className="text-gold font-semibold tracking-wide">
            Website Design:{" "}
            <a
              href="https://www.tceproductions.co.uk"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-4 hover:opacity-80 transition-opacity"
              data-testid="footer-tce-link"
            >
              www.tceproductions.co.uk
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
